import { acceptedForms, canonicalForm } from "./answer.js";

/** One line of the printed sheet (issue #102). */
export interface SheetRow {
  /** The German word, first accepted form: what the child sees. */
  prompt: string;
  /** Every accepted form of the foreign word, for the solution page. */
  answers: string[];
}

/**
 * The words of a list for writing out by hand: German on the left, a blank
 * line on the right, and the solution on its own page in the same order.
 * Mixed, so the child cannot recite the list from memory; seeded, so the
 * sheet and its solution agree and «Neu mischen» is one new seed. Pure and
 * runs in the browser: printing costs the worker nothing.
 */
export function printSheet(items: ReadonlyArray<{ a: string; b: string }>, seed: number): SheetRow[] {
  const rows = items.map((item) => ({ prompt: canonicalForm(item.a), answers: acceptedForms(item.b) }));
  const random = mulberry32(seed);
  for (let i = rows.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [rows[i], rows[j]] = [rows[j]!, rows[i]!];
  }
  return rows;
}

/** A small seeded generator; Math.random cannot be replayed. */
function mulberry32(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4_294_967_296;
  };
}
